import { ErrorHandler, Injectable } from '@angular/core';
import { GAnalyticsService } from './services/g-analytics.service';
import { environment } from '../environments/environment';

@Injectable()
export class MyErrorHandler extends ErrorHandler {
  constructor(private gAnalyticsService: GAnalyticsService) {
    super();
  }

  handleError(error: TypeError): void {
    // do something with the exception

    this.gAnalyticsService.setEvent('error', 'Errors');
    if (!environment.production) {
      super.handleError(error);
    }
  }
}
